import { createFileRoute } from '@tanstack/react-router'
import MeetingOrLivestreamPage from '@/components/pages/MeetingOrLivestreamPage.jsx'

export const Route = createFileRoute('/_authenticated/livestream/$id')({
  component: MeetingOrLivestreamPage,
})
